<template>
  <div>
    <el-form ref="formSearch" :inline="true" :model="form" label-width="100px">
      <el-form-item label="买家昵称:" v-if="tableType == 1 || tableType == 3">
        <el-input size="small" v-model="form.pin" placeholder="请输入买家昵称"></el-input>
      </el-form-item>
       <el-form-item label="买家姓名:" v-if="tableType == 1 || tableType == 3">
        <el-input size="small" v-model="form.fullName" placeholder="请输入买家姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号码:" v-if="tableType == 1 || tableType == 3">
        <el-input size="small" v-model="form.mobile" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="客户类型:" v-if="!flagTotal">
        <el-select v-model="form.customerType">
          <el-option v-for="(item, index) in customType" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户类型:" v-if="flagTotal">
        <el-select v-model="form.orderPayFlag">
          <el-option v-for="(item, index) in allCustomType" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单金额:" v-if="tableType == 3" class="input-range">
        <el-input v-model="form.orderTotalPriceStart"></el-input>
        <span class="to-size">至</span>
        <el-input v-model="form.orderTotalPriceEnd"></el-input>
      </el-form-item>
      <el-form-item label="实付金额:" v-if="tableType == 3" class="input-range">
        <el-input v-model="form.orderPaymentStart"></el-input>
        <span class="to-size">至</span>
        <el-input v-model="form.orderPaymentEnd"></el-input>
      </el-form-item>
      <el-form-item label="商品ID:" v-if="tableType == 1 || tableType == 2">
        <el-input size="small" v-model="form.skuId" placeholder="请输入商品ID"></el-input>
      </el-form-item>
       <el-form-item :label="tableType == '3' ? '下单时间:': '选择时间:'">
         <el-select style="width: 140px;margin-right:12px"  @change="switchType" v-model="timeTypeValue">
          <el-option v-for="(item, index) in timeType" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
        <div class="my_select_time" style="margin-right: 77px">
            <el-date-picker
                prefix-icon="no_icon"
                v-model="form.orderStartTimeStart"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px;font-size:12px"
                class="time1"
                :clearable="false">
            </el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
                prefix-icon="no_icon"
                v-model="form.orderStartTimeEnd"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px;font-size:12px"
                class="time2"
                :clearable="false">
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
        </div>
      </el-form-item>
      <div style="text-align: center;margin-bottom:20px">
      <el-button size="small" class="search" type="primary" @click="submitForm('formSearch')"> 
          <i class="el-icon-search" style="display:inline-block;width:14px;height:12px"></i> 查询
      </el-button>
       <el-button size="small" class="reset" type="primary" plain @click="resetForm" v-if="tableType!='1'">重置</el-button>
       <el-button size="small" class="reset" type="primary"  @click="importData" v-if="tableType=='1'">导出</el-button>
    </div>
    </el-form>


    <div class="table-box">
       <el-table
              v-loading="tableLoading"
              ref="orderTable"
              style="width: 100%; border: 1px solid #eee"
              :header-cell-style="{background:'#FAFAFA'}"
              :data="tableData"
              tooltip-effect="light"
            >
             <el-table-column key="pin" v-if="tableType == '1' || tableType == '3'" prop="pin" label="买家昵称"></el-table-column>
             <el-table-column key="fullName" v-if="tableType == '1' || tableType == '3'" prop="fullName" label="买家姓名"></el-table-column>
             <el-table-column key="mobile" v-if="tableType == '1' || tableType == '3'" prop="mobile" label="手机号码">
               <template slot-scope="scope">
                 {{scope.row.mobile || '--'}}
               </template>
             </el-table-column>

             <el-table-column key="orderId" v-if="tableType == '3'" prop="orderId" label="订单编号"></el-table-column>
             <el-table-column key="orderTotalPrice1" v-if="tableType == '3'" prop="orderTotalPrice" sortable label="订单金额"></el-table-column>
             <el-table-column key="orderPayment" v-if="tableType == '3'" prop="orderPayment" sortable label="实付金额"></el-table-column>
             <el-table-column key="orderStartTime" v-if="tableType == '3'" prop="orderStartTime" sortable label="下单时间"></el-table-column>

            <!-- 非营销汇总 -->
              <template v-if="!flagTotal">
                <el-table-column key="orderCount" v-if="tableType == '1'" prop="orderCount" label="订单数"></el-table-column>
                <el-table-column key="totalPayment1" v-if="tableType == '1'" prop="totalPayment" label="实付金额"></el-table-column>
                <el-table-column key="itemCount" v-if="tableType == '1'" prop="itemCount" label="商品件数"></el-table-column>
              </template>

             <!-- 营销汇总 -->
              <template v-if="flagTotal">
                <el-table-column key="totalOrder1" v-if="tableType == '1'" prop="totalOrder" label="订单数"></el-table-column>
                <el-table-column key="orderTotalPrice2" v-if="tableType == '1'" prop="orderTotalPrice" label="实付金额"></el-table-column>
                <el-table-column key="totalItems" v-if="tableType == '1'" prop="totalItems" label="商品件数"></el-table-column>
              </template>
             

            <el-table-column key="skuName" v-if="tableType == '2'" prop="skuName" label="商品名称（展开全部）"></el-table-column>
            <el-table-column key="jdPrice" v-if="tableType == '2'" prop="jdPrice" label="单价（元）"></el-table-column>
            <el-table-column key="totalPin" v-if="tableType == '2'" prop="totalPin" label="客户数"></el-table-column>
            <el-table-column key="totalOrder2" v-if="tableType == '2'" prop="totalOrder" label="订单数"></el-table-column>
            <el-table-column key="totalPayment2" v-if="tableType == '2'" prop="totalPayment" label="实付金额"></el-table-column>
            <el-table-column key="totalItem" v-if="tableType == '2'" prop="totalItem" label="商品件数"></el-table-column>
       </el-table>
        <!-- 分页器 -->
        <div>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="form.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import {getDetailCustomer, getDetailWare, getDetailOrder} from "@/api/smsMarketing";
import { getActivityCompare, getAnalyzingItemDetailVoList } from "@/api/marketing/batchListSummary"

export default {
  props: {
    tableType: {
      type: Number,
      default: 2, //1. 表示客户详情 2.表示商品详情 3.订单详情
    },
    startTimeProp: { // 近几天的开始时间
      type: String, 
      default: ''
    },
    flagTotal: {
      type: Boolean,
      default: false, // 是否为营销汇总分析 调的接口不一样
    },
    taskId: {
      type: null,
      default: ''
    },
    batchId: {
      type: null,
      default: ''
    }
  },

  name: '',
  data() {
    return {
      form: {
        pin: '',
        fullName: '',
        mobile: '',
        customerType: '',
        skuId: '',
        orderStartTimeStart: '',
        orderStartTimeEnd: '',
        orderPaymentStart: '',
        orderPaymentEnd: '',
        orderTotalPriceStart: '', // 订单金额
        orderTotalPriceEnd: '',
        orderPayFlag: '', // 客户类型-营销汇总分析的客户类型

        size: 10,
        current: 1
      },
      tableLoading: false,
      tableData: [],
      params: {},
      total: 0,
      customType: [
      //   {
      //   label: '全部客户',
      //   value: ''
      // },
      {
        label: '拍单客户',
        value: '1'
      },
      {
        label: '成交客户',
        value: '2'
      },
      {
        label: '拍单未付款客户',
        value: '3'
      }],
      allCustomType: [
        {
          label: '全部客户',
          value: ''
        },
        {
          label: '已支付',
          value: 0
        },
        {
          label: '未支付',
          value: 1
        },
      ],
      timeTypeValue: '7',
      timeType: [ {
        label: '自定义',
        value: ''
      },
      {
        label: '近7天',
        value: '7'
      },
       {
        label: '近15天',
        value: '15'
      },
      {
        label: '近30天',
        value: '30'
      },
      ]
    }
  },
  mounted() {
    console.log('777')
    this.switchType(7);
    this.submitForm();
  },
  watch: {
    tableType(nVal, oVal) {
      console.log(nVal)
      this.switchType(7);
      this.submitForm();
    }
  },
  methods: {
    // 导出数据接口
    importData() {

    },
    switchType(val) {
      if (val && this.startTimeProp) {
        var startTime = this.startTimeProp;
        this.form.orderStartTimeStart = startTime;

        var dd = new Date(startTime);
        dd.setDate(dd.getDate() + val);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        var endTime = y + "-" + m + "-" + d;
        this.form.orderStartTimeEnd = endTime;
      }
    },

    submitForm() {
      if (this.tableType == '1') {
        // 客户详情
        this.getCustomerList();
      }else if (this.tableType == '2') {
        // 商品详情
        this.getGoodsDetail();
      }else if (this.tableType == '3') {
        // 订单详情
        this.getDetailOrder();
      }
    },
    /** 查询订单详情  */
    getDetailOrder() {
      this.tableLoading = true;
      var form = this.form;
      var param = {
          pin: form.pin,
          fullName: form.fullName,
          mobile: form.mobile,
          customerType: form.customerType,

          orderTotalPriceStart: form.orderTotalPriceStart,
          orderTotalPriceEnd: form.orderTotalPriceEnd,
          orderPaymentStart: form.orderPaymentStart,
          orderPaymentEnd: form.orderPaymentEnd,
          orderStartTimeStart: form.orderStartTimeStart,
          orderStartTimeEnd: form.orderStartTimeEnd,
          current: form.current,
          size: form.size,
          batchId: this.batchId,
        };

     
      getDetailOrder(param).then(res => {
        this.tableLoading = false;
        if (res.code == '1') {
          this.tableData = res.data.records;
          this.total = +res.data.total;
        }
      })
    },

    /** 查询商品详情 */
    getGoodsDetail() {
      this.tableLoading = true;
      if (!this.flagTotal) {
        var form = this.form;
        var param = {
          customerType: form.customerType,
          skuId: form.skuId,
          orderStartTimeStart: form.orderStartTimeStart,
          orderStartTimeEnd: form.orderStartTimeEnd,
          current: form.current,
          size: form.size,
          batchId: this.batchId,
        };
        getDetailWare(param).then(res => {
          this.tableLoading = false;
          if (res.code == '1') {
            this.tableData = res.data.records;
            this.total = +res.data.total;
          }
        })
      } else {
        // 营销效果汇总分析
        var form = this.form;
        var param = {
          orderPayFlag: form.orderPayFlag,
          wareId: form.skuId,
          startTime: form.orderStartTimeStart,
          endTime: form.orderStartTimeEnd,
          taskId: this.taskId,
          current: form.current,
          size: form.size
        }
        getAnalyzingItemDetailVoList(param).then(res => {
          this.tableLoading = false;
          if (res.code == '1') {
            this.tableData = res.data.records;
            this.total = +res.data.total;
          }
        })
      }
     
    },
     /**  查询获取客户详情数据 */
    getCustomerList() {
      this.tableLoading = true;
      if (!this.flagTotal) {
        var form = this.form;
        var param = {
          pin: form.pin,
          fullName: form.fullName,
          mobile: form.mobile,
          customerType: form.customerType,

          skuId: form.skuId,
          orderStartTimeStart: form.orderStartTimeStart,
          orderStartTimeEnd: form.orderStartTimeEnd,
          current: form.current,
          size: form.size,
          batchId: this.batchId,
        };



         getDetailCustomer(param).then(res => {
          this.tableLoading = false;
          if (res.code == '1') {
            this.tableData = res.data.records;
            this.total = +res.data.total;
          }
        })
      }else {
        // 营销汇总分析
        var form = this.form;
        var param = {
          pin: form.pin,
          fullName: form.fullName,
          mobile: form.mobile,
          orderPayFlag: form.orderPayFlag,
          wareId: form.skuId,
          startTime: form.orderStartTimeStart,
          endTime: form.orderStartTimeEnd,
          taskId: this.taskId,
          current: form.current,
          size: form.size
        }
        getActivityCompare(param).then(res => {
          this.tableLoading = false;
          if (res.code == '1') {
            this.tableData = res.data.records;
            this.total = +res.data.total;
          }
        })

      }
     
    },
    clearTime() {
      this.form.orderStartTimeStart = '';
      this.form.orderStartTimeEnd = '';
    },
    resetForm() {
      this.form = {
        pin: '',
        fullName: '',
        mobile: '',
        customerType: '',
        skuId: '',
        orderStartTimeStart: '',
        orderStartTimeEnd: '',
        orderPaymentStart: '',
        orderPaymentEnd: '',
        orderTotalPriceStart: '',
        orderTotalPriceEnd: '',
        size: 10,
        current: 1
      }
      this.switchType(7);
      this.submitForm();
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.submitForm();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.submitForm();
    }
  }
}
</script>
<style lang="scss" scoped>
.el-input, .el-select{
  width: 280px;
}
.input-range .el-input{
  width: 125px;
}
.input-range .to-size{
  padding: 0 8px;
}
.search{
        width: 98px;
      height: 32px;
      color: #fe4d45;
border-radius: 3px;
      border: 1px solid #fe4d45 ;
      background-color: #fff;
   &:hover{
      color: #fff ;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  &:active {
    color: #fff ;
      border: 1px solid #fff;
      background-color: #fe4d45;
  }
}
.reset{
        width: 98px;
      height: 32px;
      color: #666666;
border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
  &:active {
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
  }
}
</style>